<ng-container *ngIf="scaledPath(); let scaledPath">
  <ng-container *ngIf="!clipData">
    <ng-container *ngIf="delayedRendering">
      <svg:path
        [class]="getClassTag('hoverarea')"
        [attr.d]="sectionPath(scaledPath)"
        (mouseup)="onEdgeLineClick($event)"
      />

      <ng-container *ngIf="showHeadwayBand()">
        <svg:path
          [class]="getClassTag('edge_line headway_band bandarea ')"
          [attr.d]="sectionBandPath(scaledPath)"
          (mouseup)="onEdgeLineClick($event)"
        />
      </ng-container>
    </ng-container>

    <svg:path
      [class]="getClassTag('edge_line')"
      [attr.d]="sectionPath(scaledPath)"
      (mouseup)="onEdgeLineClick($event)"
    />

    <ng-container *ngIf="delayedRendering">
      <ng-container *ngIf="showDeparture()">
        <svg:g [attr.transform]="getDepartureTextTransformation(scaledPath)">
          <svg:text
            [class]="getDepartureClassTag('edge_text DepartureTime')"
            x="0"
            y="0"
            [attr.style]="getDepartureTextStyle()"
            (mouseup)="openTrainrunSectionDialogDeparture($event, trainrunItem)"
          >
            {{ getDepartureText() }}
          </svg:text>
        </svg:g>
      </ng-container>

      <ng-container *ngIf="showArrival()">
        <svg:g [attr.transform]="getArrivalTextTransformation(scaledPath)">
          <svg:text
            [class]="getArrivalClassTag('edge_text ArrivalTime')"
            x="0"
            y="0"
            [attr.style]="getArrivalTextStyle()"
            (mouseup)="openTrainrunSectionDialogArrival($event, trainrunItem)"
          >
            {{ getArrivalText() }}
          </svg:text>
        </svg:g>
      </ng-container>

      <ng-container *ngIf="showText()">
        <svg:g [attr.transform]="getTextTransform()">
          <svg:g [attr.transform]="getTextLabelTransformation(scaledPath)">
            <svg:text
              [class]="getClassTag('edge_text TextLabel')"
              x="0"
              y="0"
              (mouseup)="openTrainrunDialog($event, trainrunItem)"
            >
              {{ getText() }}
            </svg:text>
          </svg:g>
        </svg:g>
      </ng-container>

      <ng-container *ngIf="showTrainRunSectionStops && hasStops()">
        <svg:g
          sbb-train-run-section-stops-component
          [scaledPath]="scaledPath"
          [trainrun]="trainrun"
          [trainrunItem]="trainrunItem"
          [freqOffset]="freqOffset"
        ></svg:g>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
